import { Group, Stack } from '@mantine/core';
import type { FeatureInformation } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { PermissionSelect } from './PermissionSelect';
import { ResourcesCustomFilters } from './ResourcesCustomFilters';
import type { IamRoleFormValues } from './types';

export function FeaturePermissionSetting({
	feature,
	form,
	disabled = false,
}: {
	feature: FeatureInformation;
	form: IamRoleFormValues;
	disabled?: boolean;
}) {
	return (
		<Stack spacing="xs">
			{feature.name !== 'Resources' && (
				<Group position="apart">
					<Text size="sm" color="text/primary/default" weight="semibold">
						{feature.label}
					</Text>
					<PermissionSelect form={form} feature={feature} disabled={disabled} />
				</Group>
			)}
			{feature.name === 'Resources' && (
				<ResourcesCustomFilters
					form={form}
					feature={feature}
					disabled={disabled}
				/>
			)}
		</Stack>
	);
}
